import { gql } from "@apollo/client";
import {
  AuthenticationMethodDeepNestingFragment,
  MfaMethodDeepNestingFragment,
  RoleDeepNestingFragment,
  UserV2DeepNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";

export const UpdateMeMutation = gql`
  ${UserV2DeepNestingFragment}
  ${AuthenticationMethodDeepNestingFragment}
  ${RoleDeepNestingFragment}
  ${MfaMethodDeepNestingFragment}
  mutation UpdateMe($input: UpdateMeInput!) {
    updateMe(input: $input) {
      ...UserV2DeepNesting
    }
  }
`;
